






import { defineComponent } from "@vue/composition-api";

/**
 * 空组件
 */
export default defineComponent({
  props: {
    text: {
      type: String,
      default: "暂无数据",
    },
  },
});
